import {CardElement} from "@stripe/react-stripe-js";
import {useMemo} from '@wordpress/element';

const StripeCardForm = ({data, billing, onChange: eventChange}) => {
    const onChange = (event) => {
        eventChange(event);
    }

    const cardOptions = useMemo(() => {
        return {
            ...{
                value: {
                    postalCode: billing?.billingAddress?.postcode
                },
                hidePostalCode: false,
                iconStyle: 'default'
            },
            ...data.cardOptions
        };
    }, [billing.billingAddress]);
    return (
        <div className='wc-stripe-inline-form'>
            <CardElement options={cardOptions} onChange={onChange}/>
        </div>
    )
}

export default StripeCardForm;